module.exports = __webpack_public_path__ + "media/Indoor Archery.eb74e5d0.mp4";